import api from '@services/api';
import { Collaborator, DisableInput, PersonSearchInput } from '../models/collaborator';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all person related CRUD calls
 */

export const PersonApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchPerson: builder.query<PaginationResponse<Collaborator>, PersonSearchInput>({
      query: (input: PersonSearchInput) => ({
        url: encodeURI(
          `/indirect/person/search?available=${input.available}&searchTerm=${input.searchTerm}&page=${input.page}&size=${input.size}&sortKey=${input.sortKey}&sortDirection=${input.sortDirection}`,
        ),
      }),
      providesTags: ['Person'],
    }),
    searchAllPerson: builder.query<PaginationResponse<Collaborator>, PersonSearchInput>({
      query: (parans: PersonSearchInput) => {
        const searchTerm = parans.searchTerm ?? '';
        return {
          url: encodeURI(
            `/indirect/person/searchAll?searchTerm=${searchTerm}&page=${parans.page}&size=${parans.size}&sortKey=name&sortDirection=ASC`,
          ),
          method: 'GET',
        };
      },
      providesTags: ['Person'],
    }),
    disableAll: builder.mutation<void, DisableInput>({
      query: (input: DisableInput) => ({
        url: encodeURI(`/indirect/person/disableAll`),
        body: input,
        method: 'PUT',
      }),
      invalidatesTags: ['Person'],
    }),
    enableAll: builder.mutation<void, DisableInput>({
      query: (input: DisableInput) => ({
        url: encodeURI(`/indirect/person/enableAll`),
        body: input,
        method: 'PUT',
      }),
      invalidatesTags: ['Person'],
    }),
  }),
});

export const { useSearchPersonQuery, useSearchAllPersonQuery, useDisableAllMutation, useEnableAllMutation } = PersonApi;
